exports.install = function (Vue,options) {
  Vue.prototype.allow = function (permission){
    if(this.$route.meta.rights) {
      return this.$route.meta.rights[permission];
    } else {
      return false;
    }
  };
}
